export const BanhoTosa = (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.35966 10.8936C2.46828 10.3786 2.16325 9.24021 2.67768 8.34846C2.80612 8.1249 3.09097 8.04858 3.31398 8.17796L12.2234 13.3218C12.5046 13.1186 12.8246 12.9609 13.1801 12.8657C14.7186 12.4534 16.2975 13.365 16.7098 14.9035C17.1218 16.4411 16.2104 18.021 14.6719 18.4333C13.1333 18.8455 11.5318 17.9389 11.1198 16.4014C11.0246 16.0459 11.0235 15.6839 11.0589 15.3388L9.79763 14.6484L9.09529 15.8649C9.29851 16.1461 9.4562 16.4662 9.55143 16.8216C9.96342 18.3592 9.0521 19.9391 7.51355 20.3513C5.976 20.7633 4.39582 19.851 3.98383 18.3134C3.57158 16.7749 4.48416 15.1957 6.02172 14.7837C6.37715 14.6885 6.73316 14.665 7.07831 14.7004L7.78065 13.4839L3.35966 10.8936ZM6.42558 16.3805C5.78904 16.551 5.37572 17.2345 5.55221 17.8932C5.72876 18.5521 6.4284 18.9371 7.06494 18.7666C7.74598 18.5841 8.11488 17.9128 7.93832 17.2538C7.76183 16.5952 7.10662 16.198 6.42558 16.3805ZM15.119 15.3298C14.9425 14.6711 14.265 14.2799 13.6063 14.4564C12.9476 14.6329 12.5564 15.3105 12.7329 15.9691C12.9095 16.6281 13.587 17.019 14.2457 16.8425C14.9043 16.666 15.2956 15.9887 15.119 15.3298ZM11.3897 11.8908L9.37275 10.7263L12.2221 5.79103C12.3513 5.56727 12.6347 5.49135 12.8584 5.62053C13.7503 6.13546 14.0554 7.27384 13.5404 8.16572L11.3897 11.8908Z"
      fill="#00A6CE"
    />
    <path
      d="M18.2959 4.15883C18.8293 4.01589 19.3777 4.33247 19.5206 4.86594L22.3676 15.4911C22.5106 16.0246 22.194 16.5729 21.6605 16.7159L20.6946 16.9747L17.3299 4.41765L18.2959 4.15883Z"
      fill="#00A6CE"
    />
    <path
      d="M17.3299 4.41765L17.589 5.38352L16.1401 5.77175C15.8733 5.84322 15.5992 5.68493 15.5277 5.41819C15.4562 5.15146 15.6145 4.87729 15.8813 4.80582L17.3299 4.41765Z"
      fill="#00A6CE"
    />
    <path
      d="M17.7184 5.86648L17.9772 6.83241L16.5283 7.22064C16.2616 7.29211 15.9874 7.13382 15.9159 6.86708C15.8445 6.60035 16.0028 6.32618 16.2695 6.25471L17.7184 5.86648Z"
      fill="#00A6CE"
    />
    <path
      d="M18.1066 7.31537L18.3654 8.2813L16.9165 8.66953C16.6498 8.741 16.3756 8.5827 16.3042 8.31597C16.2327 8.04924 16.391 7.77507 16.6577 7.7036L18.1066 7.31537Z"
      fill="#00A6CE"
    />
    <path
      d="M18.4948 8.76426L18.7537 9.73019L17.3048 10.1184C17.038 10.1899 16.7639 10.0316 16.6924 9.76486C16.6209 9.49813 16.7792 9.22396 17.0459 9.15249L18.4948 8.76426Z"
      fill="#00A6CE"
    />
    <path
      d="M18.8831 10.2131L19.1419 11.1791L17.693 11.5673C17.4263 11.6388 17.1521 11.4805 17.0806 11.2137C17.0092 10.947 17.1674 10.6728 17.4342 10.6014L18.8831 10.2131Z"
      fill="#00A6CE"
    />
    <path
      d="M19.2713 11.662L19.5301 12.628L18.0812 13.0162C17.8145 13.0877 17.5403 12.9294 17.4689 12.6626C17.3974 12.3959 17.5557 12.1217 17.8224 12.0503L19.2713 11.662Z"
      fill="#00A6CE"
    />
    <path
      d="M19.6595 13.1109L19.9183 14.0769L18.4695 14.4651C18.2027 14.5366 17.9286 14.3783 17.8571 14.1115C17.7856 13.8448 17.9439 13.5706 18.2106 13.4992L19.6595 13.1109Z"
      fill="#00A6CE"
    />
    <path
      d="M20.0478 14.5598L20.3066 15.5257L18.8577 15.914C18.5909 15.9854 18.3168 15.8271 18.2453 15.5604C18.1738 15.2937 18.3321 15.0195 18.5989 14.948L20.0478 14.5598Z"
      fill="#00A6CE"
    />
    <path
      d="M20.436 16.0087L20.6946 16.9747L19.2459 17.3629C18.9792 17.4343 18.705 17.276 18.6335 17.0093C18.5621 16.7426 18.7204 16.4684 18.9871 16.3969L20.436 16.0087Z"
      fill="#00A6CE"
    />
  </svg>
);

export const PersonalPetIcon = (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.082 9.37109L15 6.25V1.25C15 0.559766 14.4402 0 13.75 0H12.5C12.3145 0 12.1338 0.0549219 11.9801 0.157461L11.0035 0.808242C9.63516 1.72152 7.86758 1.72152 6.4957 0.808242L5.51914 0.157461C5.36719 0.0549219 5.1875 0 5 0H3.75C3.05977 0 2.5 0.559766 2.5 1.25V6.25L0.419922 9.37109C0.146094 9.78125 0 10.2617 0 10.7578V18.75C0 19.4402 0.559766 20 1.25 20H7.5V11.25C7.5 11.1157 7.52167 10.9822 7.56418 10.8547L8.09113 9.27344L5.86719 2.6C6.76562 3.10273 7.75391 3.36914 8.75 3.36914C9.74609 3.36914 10.734 3.10258 11.6332 2.6L8.75 11.25V20H16.25C16.9402 20 17.5 19.4402 17.5 18.75V10.7578C17.5 10.2617 17.3555 9.78125 17.082 9.37109ZM2.48047 10.6445C2.29859 10.4614 2.29859 10.1637 2.48047 9.98047C2.66359 9.79734 2.96133 9.79734 3.14453 9.98047L3.75 10.5859L4.35547 9.98047C4.53859 9.79734 4.83633 9.79734 5.01953 9.98047C5.20141 10.1636 5.20141 10.4613 5.01953 10.6445L4.41406 11.25L5.01953 11.8555C5.20141 12.0386 5.20141 12.3363 5.01953 12.5195C4.92969 12.6094 4.80859 12.6562 4.6875 12.6562C4.56641 12.6562 4.44703 12.6111 4.35547 12.5195L3.75 11.9141L3.14453 12.5195C3.05312 12.6094 2.93203 12.6562 2.8125 12.6562C2.69297 12.6562 2.57203 12.6111 2.48047 12.5195C2.29859 12.3364 2.29859 12.0387 2.48047 11.8555L3.08594 11.25L2.48047 10.6445ZM3.75 17.8125C2.88711 17.8125 2.1875 17.1129 2.1875 16.25C2.1875 15.3871 2.88711 14.6875 3.75 14.6875C4.61289 14.6875 5.3125 15.3867 5.3125 16.25C5.3125 17.1133 4.61328 17.8125 3.75 17.8125ZM14.0312 13.1172L12.1367 13.125C11.957 13.125 11.8398 13.0078 11.875 12.8633L11.8834 10.9676C11.8891 10.4051 12.3729 9.95273 12.9463 10.0039C13.4459 10.0493 13.8108 10.4969 13.808 10.9969L13.8059 11.1952L14.0039 11.1929C14.505 11.1916 14.9507 11.5552 14.9961 12.0554C15.0469 12.6289 14.5977 13.1133 14.0312 13.1172Z"
      fill="#7EB339"
    />
  </svg>
);

export const boltIcon = (
  <svg
    width="9"
    height="15"
    viewBox="0 0 9 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.35036 4.99998H5.22498L6.37871 1.61977C6.48705 1.22394 6.17559 0.833313 5.75039 0.833313H1.85043C1.52544 0.833313 1.24919 1.06508 1.20586 1.37498L0.339199 7.62498C0.287741 7.99998 0.591071 8.33331 0.983775 8.33331H4.19853L2.95 13.3984C2.8525 13.7943 3.16667 14.1666 3.58104 14.1666C3.80853 14.1666 4.0252 14.0521 4.14436 13.8541L8.91098 5.93748C9.16285 5.52342 8.85139 4.99998 8.35036 4.99998Z"
      fill="#FFFFFF"
    />
  </svg>
);

export const percentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.72,5.96A2.279,2.279,0,0,0,17.857,5H5.286A2.292,2.292,0,0,0,3,7.286V18.714A2.285,2.285,0,0,0,5.286,21H17.857a2.289,2.289,0,0,0,1.863-.971L24.714,13,19.72,5.96M9.229,8.463a1.623,1.623,0,1,1-1.623,1.623A1.629,1.629,0,0,1,9.229,8.463m5.829,9.074a1.623,1.623,0,1,1,1.623-1.623,1.629,1.629,0,0,1-1.623,1.623m-6.114.034L7.571,16.2l7.771-7.771L16.714,9.8Z"
      transform="translate(-2 -1)"
    />
    <rect fill="none" width="16" height="16" />
  </svg>
);
